import {
  getCodeCultures,
  getCodeListWithCulture,
  getRegion,
  getArea,
  getFactory,
  getMultiAreasFactory,
  getLocation,
  getCartype,
  getGate,
  getJob,
  getCarColor,
  getCaptcha,
  getUserRoleList,
  addOrUpdateFactoryLocation,
  getFactoryLocationTable,
  deleteFactoryLocation,
  addOrUpdateFactoryCarType,
  getFactoryCartypeTable,
  deleteFactoryCartype,
  getRole,
  searchEmpUser,
  getUserInfo,
  upsertAuth,
  getAuthTable,
  deleteAuth,
  getGateByCartypeNArea,
  createVendor,
  queryOAcodeList,
  queryOAcodeListWithArea,
  getVendorTable,
  getVendorInfo,
  disableVendorDriver,
  disableVendorCar,
  upsertVendor,
  getSsoToken,
  getCurrentUser,
  getUserAuthInfo,
  getGuardRight,
  getVendorByOACode,
  getVendorAreaByOACode,
  getVendorFactoryById,
  getLocationByFactory,
  getEnterReason,
  saveAndSubmitReserveData,
  upsertReserveByUser,
  mailService,
  getReserveTable,
  getReserveIDByParams,
  getMyReserveTable,
  getQueryReserveTable,
  getExportReserveTable,
  getExportInspectHistory,
  getReserveInfo,
  upsertInspectByGuard,
  getReleaseNum,
  getSOTableBindingWithReserve,
  updateReserveFlow,
  getReserveCountForGuard,
  getReserveListForGuard,
  getLDPA,
  disableVendor,
  resetVendorPassword,
  getVendorWithPasswordChage,
  getReleaseTable,
  getExportReleaseTable,
  saveOrSubmitReleaseData,
  cancelReleaseData,
  checkReleaseAllFinishedSign,
  updateRelease,
  getReleaseInfo,
  getSOCredit,
  updateSO,
  updateReleaseANSo,
  updateSignList,
  getSignTable,
  approvalRelease,
  getReleaseTableWithSign,
  getApprovalReleaseTableForMobile,
  updateReleaseANSign,
  getFactoryByOAcode,
  getRegionAreaByFactory,
  updateReleaseStatus,
  getCompanyNameByPlantCode,
  updateSoToERP,
  postReleaseStatusToERP,
  getJITList,
  getJITExcelList,
  addJITData,
  getSameReserveWithDifferentFactory,
  disableJITData,
  getGuardShiftList,
  uploadGuardShift,
  getGuardShiftSampleFile,
  updateSystemSettingValue,
  getSystemSettingValue,
  updataReserveStatus,
  updateReleaseStatusByReleaseID,
  runJITAutoReserve,
} from "@/utils/api_construction.js"

export var api = {
  apiGetLDPA: function (data) {
    return getLDPA(data)
  },
  apiGetSsoToken: function () {
    return getSsoToken()
  },
  apiMailService: function (data) {
    return mailService(data)
  },
  /***************-BASE-***************/
  apiGetCodeCultures: function () {
    return getCodeCultures()
  },
  apiGetCodeListWithCulture: function (data) {
    return getCodeListWithCulture(data)
  },
  apiGetRegion: function (data) {
    return getRegion(data)
  },
  apiGetArea: function (data) {
    return getArea(data)
  },
  apiGetFactory: function (data) {
    return getFactory(data)
  },
  apiGetMultiAreasFactory: function (data) {
    return getMultiAreasFactory(data)
  },
  apiGetLocation: function () {
    return getLocation()
  },
  apiGetCartype: function () {
    return getCartype()
  },
  apiGetGate: function () {
    return getGate()
  },
  apiGetRole: function () {
    return getRole()
  },
  apiGetJob: function () {
    return getJob()
  },
  apiGetCarColor: function () {
    return getCarColor()
  },
  apiGetCaptcha: function () {
    return getCaptcha()
  },
  apiGetUserRoleList: function (userNT) {
    return getUserRoleList(userNT)
  },
  apiGetEnterReason: function () {
    return getEnterReason()
  },
  apiGetRegionAreaByFactory: function (data) {
    return getRegionAreaByFactory(data)
  },
  /***************-FACTORY MAINTAIN-***************/
  apiGetLocationByFactory: function (data) {
    return getLocationByFactory(data)
  },
  apiGetGateByCartypeNArea: function (data) {
    return getGateByCartypeNArea(data)
  },
  apiGetFactoryLocationTable: function (data) {
    return getFactoryLocationTable(data)
  },
  apiAddOrUpdateFactoryLocation: function (data) {
    return addOrUpdateFactoryLocation(data)
  },
  apiDeleteFactoryLocation: function (data) {
    return deleteFactoryLocation(data)
  },
  apiGetFactoryCartypeTable: function (data) {
    return getFactoryCartypeTable(data)
  },
  apiAddOrUpdateFactoryCarType: function (data) {
    return addOrUpdateFactoryCarType(data)
  },
  apiDeleteFactoryCartype: function (data) {
    return deleteFactoryCartype(data)
  },
  /***************-AUTH-***************/
  apiSearchEmpUser: function (data) {
    return searchEmpUser(data)
  },
  apiGetUserInfo: function (data) {
    return getUserInfo(data)
  },
  apiUpsertAuth: function (data) {
    return upsertAuth(data)
  },
  apiDeleteAuth: function (data) {
    return deleteAuth(data)
  },
  apiGetAuthTable: function (data) {
    return getAuthTable(data)
  },
  apiGetUserAuthInfo: function (data) {
    return getUserAuthInfo(data)
  },
  apiGetGuardRight: function (data) {
    return getGuardRight(data)
  },
  apiGetCurrentUser: function () {
    return getCurrentUser()
  },
  /***************-VENDOR-***************/
  apiCreateVendor: function (data) {
    return createVendor(data)
  },
  apiQueryOAcodeList: function (data) {
    return queryOAcodeList(data)
  },
  apiQueryOAcodeListWithArea: function (data) {
    return queryOAcodeListWithArea(data)
  },
  apiGetVendorTable: function (data) {
    return getVendorTable(data)
  },
  apiGetVendorInfo: function (data) {
    return getVendorInfo(data)
  },
  apiUpsertVendor: function (data) {
    return upsertVendor(data)
  },
  apiGetVendorByOACode: function (data) {
    return getVendorByOACode(data)
  },
  apiGetFactoryByOAcode: function (data) {
    return getFactoryByOAcode(data)
  },
  apiGetVendorAreaByOACode: function (data) {
    return getVendorAreaByOACode(data)
  },
  apiGetVendorFactoryById: function (data) {
    return getVendorFactoryById(data)
  },
  apiDisableVendorDriver: function (data) {
    return disableVendorDriver(data)
  },
  apiDisableVendorCar: function (data) {
    return disableVendorCar(data)
  },
  apiDisableVendor: function (data) {
    return disableVendor(data)
  },
  apiResetVendorPassword: function (data) {
    return resetVendorPassword(data)
  },
  apiGetVendorWithPasswordChage: function (data) {
    return getVendorWithPasswordChage(data)
  },
  /***************-RESERVE-***************/
  apiSaveAndSubmitReserveData: function (data) {
    return saveAndSubmitReserveData(data)
  },
  apiUpsertReserveByUser: function (data) {
    return upsertReserveByUser(data)
  },
  apiGetReserveTable: function (data) {
    return getReserveTable(data)
  },
  apiGetReserveIDByParams: function (data) {
    return getReserveIDByParams(data)
  },
  apiGetMyReserveTable: function (data) {
    return getMyReserveTable(data)
  },
  apiGetQueryReserveTable: function (data) {
    return getQueryReserveTable(data)
  },
  apiGetExportReserveTable: function (data) {
    return getExportReserveTable(data)
  },
  apiGetExportInspectHistory: function (data) {
    return getExportInspectHistory(data)
  },
  apiGetReserveInfo: function (data) {
    return getReserveInfo(data)
  },
  apiGetReleaseNum: function (data) {
    return getReleaseNum(data)
  },
  apiGetSOTableBindingWithReserve: function (reserveID) {
    return getSOTableBindingWithReserve(reserveID)
  },
  apiUpdateReserveFlow: function (data) {
    return updateReserveFlow(data)
  },
  apiGetReserveCountForGuard: function (data) {
    return getReserveCountForGuard(data)
  },
  apiGetReserveListForGuard: function (data) {
    return getReserveListForGuard(data)
  },
  /***************-GUARD-***************/
  apiUpsertInspectByGuard: function (data) {
    return upsertInspectByGuard(data)
  },
  /***************-RELEASE-***************/
  apiGetReleaseTable: function (data) {
    return getReleaseTable(data)
  },
  apiExportReleaseTable: function (data) {
    return getExportReleaseTable(data)
  },
  apiSaveOrSubmitReleaseData: function (data) {
    return saveOrSubmitReleaseData(data)
  },
  apiCancelReleaseData: function (data) {
    return cancelReleaseData(data)
  },
  apiCheckReleaseAllFinishedSign: function (data) {
    return checkReleaseAllFinishedSign(data)
  },
  apiUpdateRelease: function (data) {
    return updateRelease(data)
  },
  apiGetReleaseInfo: function (data) {
    return getReleaseInfo(data)
  },
  apiGetSOCredit: function (data) {
    return getSOCredit(data)
  },
  apiUpdateSO: function (data) {
    return updateSO(data)
  },
  apiUpdateSignList: function (data) {
    return updateSignList(data)
  },
  apiUpdateReleaseANSo: function (data) {
    return updateReleaseANSo(data)
  },
  apiGetSignTable: function (data) {
    return getSignTable(data)
  },
  apiApprovalRelease: function (data) {
    return approvalRelease(data)
  },
  apiGetReleaseTableWithSign: function (data) {
    return getReleaseTableWithSign(data)
  },
  apiGetApprovalReleaseTableForMobile: function (data) {
    return getApprovalReleaseTableForMobile(data)
  },
  apiUpdateReleaseANSign: function (data) {
    return updateReleaseANSign(data)
  },
  apiUpdateReleaseStatus: function (data) {
    return updateReleaseStatus(data)
  },
  apiGetCompanyNameByPlantCode: function (data) {
    return getCompanyNameByPlantCode(data)
  },
  /**************To ERP*****************/
  apiUpdateSoToERP: function (data) {
    return updateSoToERP(data)
  },
  apiPostReleaseStatusToERP: function (data) {
    return postReleaseStatusToERP(data)
  },
  /**************JIT*****************/
  apiGetJITList: function (data) {
    return getJITList(data)
  },
  apiGetJITExcelList: function (data) {
    return getJITExcelList(data)
  },
  apiAddJITData: function (data) {
    return addJITData(data)
  },
  apiGetSameReserveWithDifferentFactory: function (data) {
    return getSameReserveWithDifferentFactory(data)
  },
  apiDisableJITData: function (data) {
    return disableJITData(data)
  },
  apiGetGuardShiftList: function (data) {
    return getGuardShiftList(data)
  },
  apiUploadGuardShift: function (data) {
    return uploadGuardShift(data)
  },
  apiGetGuardShiftSampleFile: function () {
    return getGuardShiftSampleFile()
  },
  apiGetSystemSettingValue: function (data) {
    return getSystemSettingValue(data)
  },
  apiUpdateSystemSettingValue: function (data) {
    return updateSystemSettingValue(data)
  },
  apiUpdataReserveStatus: function (data) {
    return updataReserveStatus(data)
  },
  apiUpdateReleaseStatusByReleaseID: function (data) {
    return updateReleaseStatusByReleaseID(data)
  },
  apiRunJITAutoReserve: function (data) {
    return runJITAutoReserve(data)
  },
}
